/* src/app/timeline-transport/partals/timeline-transport-chat/timeline-transport-chat.component.scss */
.chatContainer {
  position: fixed;
  top: 6rem;
  right: 0;
  bottom: 0.5rem;
  width: 20rem;
  max-width: 90vw;
  z-index: 1090;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 0.6rem 0 0 0.6rem;
  box-shadow: -2px 2px 5px rgba(15, 23, 42, 0.12);
  transform: translateX(100%);
  transition: transform 0.22s ease-out;
}
.chatContainer.chatContainerOpen {
  transform: translateX(0);
}
.chatHeader {
  flex: 0 0 auto;
  color: white;
  padding: 0.5rem 0.75rem;
  background: #1e293b;
  border-radius: 0.6rem 0 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.chatHeaderLabel {
  font-size: 0.85rem;
  font-weight: 600;
}
.chatCloseButton {
  background: transparent;
  border: 0;
  color: #f1f5f9;
  box-shadow: none;
}
.chatCloseButton:hover {
  color: #006498;
  cursor: pointer;
}
.chatMessageList {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 0.6rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.chatEmptyState {
  color: #94a3b8;
  font-size: 0.75rem;
  text-align: center;
  margin-top: 1rem;
}
.chatMessageRow {
  display: flex;
  gap: 0.4rem;
  align-items: flex-start;
}
.chatMessageRow.chatMessageRowOwn {
  flex-direction: row-reverse;
}
.chatMessageRow.chatMessageRowOwn .chatBubble {
  background: #006498;
  color: white;
}
.chatMessageRow.chatMessageRowOwn .chatBubble .chatBubbleName,
.chatMessageRow.chatMessageRowOwn .chatBubble .chatBubbleTime {
  color: rgba(255, 255, 255, 0.75);
}
.chatAvatar {
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  flex: 0 0 auto;
}
.chatBubble {
  background: #e2e8f0;
  border-radius: 0.5rem;
  padding: 0.35rem 0.6rem;
  max-width: 14rem;
  overflow-wrap: break-word;
}
.chatBubbleMeta {
  display: flex;
  gap: 0.4rem;
  align-items: baseline;
  margin-bottom: 0.1rem;
}
.chatBubbleName {
  font-size: 0.65rem;
  font-weight: 700;
  color: #475569;
}
.chatBubbleTime {
  font-size: 0.6rem;
  color: #94a3b8;
}
.chatBubbleText {
  font-size: 0.8rem;
  line-height: 1.3;
  white-space: pre-wrap;
}
.chatInputRow {
  flex: 0 0 auto;
  display: flex;
  gap: 0.4rem;
  padding: 0.5rem;
  border-top: 1px solid #e2e8f0;
}
.chatInputRow input {
  flex: 1 1 auto;
}
/*# sourceMappingURL=timeline-transport-chat.component.css.map */
